import encryption from './encryption'
import config from './config'
import qs from 'qs'
import axios from 'axios'
import cookie from './cookie'
import store from '@/store'
import hmacSHA256 from "crypto-js/hmac-sha256";
import Lang from "@/i18n";
// Sentry未使用
// import * as Sentry from '@sentry/browser';
// axios.defaults.baseURL = config.API_ROOT
axios.defaults.headers['Content-Type'] = config.CONTENT_TYPE
axios.interceptors.response.use(res => {
  delete axios.defaults.headers.token
  delete axios.defaults.headers.i18n
  delete axios.defaults.headers.sign
  // if((res.data.err && res.data.err !== 0  ) || (res.data.code && res.data.code !== 0 ) ){
  //   Sentry.setExtra('EXTRA_INFO', {
  //     error_url: res.config.params && res.config.params.action,
  //     error_code: res.data.err || res.data.code,
  //     error_message: res.data.desc,
  //     error_params:res.config.params
  //  });
  //   Sentry.setTag('url', location.href);
  //   Sentry.captureException(new Error(res.config.params && res.config.params.action + '==⨠'+ '接口异常'));
  // }
   if (
    //  res.data.code &&
    //  res.data.code !== 0 &&
     res.config.url &&
     res.config.url.indexOf('dessmonitor.com/upg') !== -1
   ) {
    //  console.log('UPG接口响应', res)
    let userName =  store.state.user.username||JSON.parse(cookie.getCookie('usr'))
    // 拼接所有参数为一个字符串，便于日志统一查看
     let paramsObj = res.config.params !== undefined ? res.config.params : res.config.data;
     let paramsStr = '';
     if (paramsObj && typeof paramsObj === 'object') {
       paramsStr = Object.keys(paramsObj).map(key => `${key}=${paramsObj[key]}`).join(';');
     }
     let codeOrstatus = `${res.data.code}${(res.data.code == 0 && res.data.data && res.data.data.status !== undefined) ? '||status:' + res.data.data.status : ''}`
    //  let resDataBase64 = (res.data.code == 0 && res.data.data) ? btoa(encodeURIComponent(JSON.stringify(res.data.data))) : ''
    //  中文/特殊字符先转 %XX 纯 ASCII，再 base64
    //  解析base64 == JSON.parse(decodeURIComponent(atob("你的base64字符串")))
     // 统一事件上报，自定义埋点事件
     trackEvent(
       "upg_response_data_dess",
       {
        // upg_url_data: `用户：${userName};时间：${getCurrentTimeString()};url:${res.config.url};接口code:${res.data.code};method:${res.config.method};参数:${paramsStr}`
        upg_url_data: [
          `用户：${userName}`,
          `时间：${getCurrentTimeString()}`,
          `url：${res.config.url}`,
          `接口code：${codeOrstatus}`,
          `method：${res.config.method}`,
          // `resDataBase64：${resDataBase64}`,
          `参数：${paramsStr}`,
        ].join('\n')
      }
     );
   }
  if (res.headers['content-disposition']) {
    return res
  } else {
    return res.data
  }


}, err => {
  // Sentry.setExtra('EXTRA_INFO', {
  //   error_url: err.response.request.responseURL,
  //   error_code: err.response.status,
  //   error_message: err.message,
  //   error_params: err.response.config.params
  // });
  // Sentry.setTag('url', location.href);
  // Sentry.captureException(new Error(err.response.config.params && err.response.config.params.action + '==⨠' + '接口异常==⨠' + err.response.status));
  ////////////////////////////
   const errorUrl = (err.config && err.config.url) || 'unknown';
   const errorMsg = err.message || '';
   const errorCode = err.code || '';
   const errorStatus = (err.response && err.response.status) || '';
  //  console.log(`Request error: URL=${errorUrl}, Message=${errorMsg}, Code=${errorCode}, Status=${errorStatus}`);
   if (
     errorUrl &&
     errorUrl.indexOf('dessmonitor.com/upg') !== -1
   ) {
    let userName = store.state.user.username||JSON.parse(cookie.getCookie('usr'))
     // 统一事件上报，自定义埋点事件
     trackEvent(
       "upg_response_error_dess",
       {
        message: [
          `用户：${userName}`,
          `时间：${getCurrentTimeString()}`,
          `url：${errorUrl}`,
          `msg：${errorMsg}`,
          `code：${errorCode}`,
          `status：${errorStatus}`
        ].join('\n')
      }
     );
   }
  if (err) {
    return Promise.reject(err)
  }
})
// request请求发送时的拦截器,服务器节点切换和控制项下发处理url
axios.interceptors.request.use(parma => {
    if (
     parma.url &&
     parma.url.indexOf('dessmonitor.com/upg') !== -1
   ) {
    // console.log('UPG接口请求了UPG接口', parma)
    let userName = store.state.user.username||JSON.parse(cookie.getCookie('usr'))
      // 拼接所有参数为一个字符串，便于日志统一查看
       let paramsObj = parma.params !== undefined ? parma.params : parma.data;
       let paramsStr = '';
       if (paramsObj && typeof paramsObj === 'object') {
         paramsStr = Object.keys(paramsObj).map(key => `${key}=${paramsObj[key]}`).join(';');
       }
     // 统一事件上报，自定义埋点事件
     trackEvent(
       "upg_request_data_dess",
       {
        // upg_url_data: `用户：${userName};时间：${getCurrentTimeString()};url:${parma.url};method:${parma.method};参数:${paramsStr}`
        upg_url_data: [
          `用户：${userName}`,
          `时间：${getCurrentTimeString()}`,
          `url：${parma.url}`,
          `method：${parma.method}`,
          `参数：${paramsStr}`,
        ].join('\n')
       }
     );
    }
    // 处理public更换为remote逻辑
  let hasMark0 = (parma.params && parma.params.mark == "0") || (parma.url && parma.url.indexOf('&mark=0') !== -1);
  let currentNode = cookie.getCookie('saveCurrentNode');
  if (currentNode) {
    let protocol = document.location.protocol + '//' + currentNode;
    parma.baseURL = hasMark0 ? protocol + '/remote/' : protocol + (config.env == "production" ? '/public/' : '/test/');
  } else {
    parma.baseURL = hasMark0
      ? (config.env == "production" ? config.API_ROOT.replace("public", "remote") : config.API_ROOT.replace("test/", "remote/"))
      : config.API_ROOT;
  }
  return parma
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
})
 // 统一事件上报，自定义埋点事件
function trackEvent(eventId, params = {}) {
  const { aplus_queue } = window;
  aplus_queue && aplus_queue.push({
    action: "aplus.record",
    arguments: [eventId, "CLK", params]
  });
}
// 时间格式化方法 当前时间
function getCurrentTimeString() {
  const d = new Date();
  const pad = n => n < 10 ? '0' + n : n;
  return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + ' '
    + pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds());
}
// 参数转为url编码
function transferUriStr(obj) {
  return qs.stringify(obj).replace(/%20/g, '+').replace(/%2B/g, '+').replace(/%3A/g, ":").replace(/%2C/g, ",").replace(/%40/g, '@').replace(/%24/g, '$').replace(/%26/g, '&').replace(/%3D/g, '=').replace(/%28/g, '(').replace(/%29/g, ')')
}
// 判断国内外节点，UPG升级相关接口根地址动态随节点切换web,web1
//切换节点后UPG请求有问题，暂时隐藏
function currentNodeUPG() {
  let savedNode = cookie.getCookie('saveCurrentNode');
  if(savedNode&&config.env == "production"){
    if (savedNode.includes('web1')) {
      return document.location.protocol + "//web1.dessmonitor.com";
    } else {
      return document.location.protocol + "//web.dessmonitor.com";
    }
   }else{
  if (config.env == "production") {
    return document.location.protocol + "//web.dessmonitor.com"
  }
  else if (config.env == "development") {
    return document.location.protocol + "//ess.dev.eybond.com"
  }
  else if (config.env == "test") {
    return document.location.protocol + "//ess.test.eybond.com"
  } else {
    return document.location.protocol + "//web.dessmonitor.com"
  }
  }
}

// production环境下 drt/alm 微服务接口统一走 web.dessmonitor.com 网关（web.dessmonitor.com/drt、web.dessmonitor.com/alm），
// 并跟随节点切换（同 currentNodeUPG：选中 web1 节点时走 web1.dessmonitor.com），
// 其余接口保持原域名，仅在 production 环境生效
function prodMicroserviceUrl(action, defaultDomain) {
  // 微服务前缀(dcs/drt/css/alm/dev/dgm)走web域名，其余保持原域名
  const microPrefixes = ['/dcs/', '/drt/', '/css/', '/alm/', '/dev/', '/dgm/'];
  if (microPrefixes.some(prefix => action.indexOf(prefix) === 0)) {
    let savedNode = cookie.getCookie('saveCurrentNode');
    if (savedNode && savedNode.includes('web1')) {
      return document.location.protocol + '//web1.dessmonitor.com' + action
    }
    return document.location.protocol + '//web.dessmonitor.com' + action
  }
  return defaultDomain + action
}

export default {
  transferUriStr: transferUriStr,
  // 导出报表调用, return 地址
  http_download_url_new(param) {
    var currUsr = {
      token: store.state.user.token,
      secret: store.state.user.secret,
    };
    var salt = new Date().getTime();
    let _baseUrl = cookie.getCookie('baseUrl')
    let baseUrl = ''
    if (cookie.getCookie('saveCurrentNode')) {
      let urlFisrst = document.location.protocol + '//' + cookie.getCookie('saveCurrentNode')
      let nodeUrl = config.env == "production" ? urlFisrst + '/public/' : urlFisrst + '/test/'
      baseUrl = _baseUrl ? _baseUrl : nodeUrl
    } else {
      baseUrl = _baseUrl ? _baseUrl : config.API_ROOT
    }
    let uriStr = transferUriStr(param)
    var sign = encryption.sha1(`${salt}${currUsr.secret}${currUsr.token}&${uriStr}`);
    var url = baseUrl + "?sign=" + sign + "&salt=" + salt + "&source=1" + "&token=" +
      currUsr.token + "&" + uriStr;
    // 下载的url地址
    return url;
  },
  // 手机注册
  phoneSignup({ usr, pwd, phone, code }) {
    let salt = new Date().getTime()
    // 密码加密
    let pwdSha1 = encryption.sha1(pwd)
    let usrSha1 = encryption.sha1(usr)
    let rc4Result = encryption.byte2hex(encryption.rc4(pwdSha1, usrSha1))
    let params = {
      action: 'regBindMobileUsually',
      usr,
      pwd: rc4Result,
      mobile: phone,
      code,
      msgType: 0,
      source: 1,
      'company-key': config.COMPANY_KEY
    }
    let uriStr = transferUriStr(params)
    let sign = encryption.sha1(`${salt}${pwdSha1}&${uriStr}`)
    params = { sign, salt, ...params }

    return axios.get('', { params })
  },
  emailSignup({ usr, pwd, code, email }) {
    let salt = new Date().getTime()
    // 密码加密
    let pwdSha1 = encryption.sha1(pwd)
    let usrSha1 = encryption.sha1(usr)
    let rc4Result = encryption.byte2hex(encryption.rc4(pwdSha1, usrSha1))

    let params = {
      action: 'regBindMailboxUsually',
      usr,
      pwd: rc4Result,
      email: email,
      code,
      channel: 1,
      msgType: 0,
      source: 1,
      'company-key': config.COMPANY_KEY
    }
    let uriStr = transferUriStr(params)
    let sign = encryption.sha1(`${salt}${pwdSha1}&${uriStr}`)
    params = { sign, salt, ...params }

    return axios.get('', { params })
  },
  // 注册
  // signup ({usr, pwd, phone, email, pn}) {
  //   let sn = pn
  //   let salt = new Date().getTime()
  //   // 密码加密
  //   let pwdSha1 = encryption.sha1(pwd)
  //   let pnSha1 = encryption.sha1(pn)
  //   let rc4Result = encryption.byte2hex(encryption.rc4(pwdSha1, pnSha1))

  //   let params = {
  //     action: 'regAddPlant',
  //     usr,
  //     pwd: rc4Result,
  //     mobile: phone,
  //     email,
  //     sn,
  //     source: 1,
  //     'company-key': config.COMPANY_KEY
  //   }
  //   let uriStr = transferUriStr(params)
  //   let sign = encryption.sha1(`${salt}${pwdSha1}&${uriStr}`)
  //   params = {sign, salt, ...params}

  //   return axios.get('', {params})
  // },
  // 认证
  verify({ usr, pwd }) {
    let salt = new Date().getTime()
    // 密码加密
    let pwdSha1 = encryption.sha1(pwd)

    let params = {
      action: 'authSource',
      // action: 'auth',
      usr,
      source: 1,
      'company-key': config.COMPANY_KEY
    }
    let uriStr = transferUriStr(params)
    let sign = encryption.sha1(`${salt}${pwdSha1}&${uriStr}`)
    params = transferUriStr({ sign, salt, ...params })
    // params = { sign, salt, ...params }

    return axios.get('?' + params)
    // return axios.get('', { params })
  },
  // 示例账号登录
  demoCodeLogin(code) {
    let baseUrl = config.env == "production" ? document.location.protocol + '//vss.eybond.com/vss/api/' : document.location.protocol + '//solar.test.eybond.com:9114/vss/api/'
    cookie.setCookie('baseUrl', baseUrl)
    let params = {
      action: 'validateInvCode',
      invCode: code,
      sysType: 1
    }
    return axios.get(baseUrl, { params })
  },
  // 申请vss的邀请码
  vssPost(params) {
    let baseUrl = document.location.protocol + '//vss.eybond.com/vss/apply/add'
    let config = {
      headers: { 'Content-Type': 'application/json' }
    }
    return axios.post(baseUrl, params, config)
  },
  //演示 获取信息
  getlink(action, data, baseUrl) {
    let url = baseUrl
    let secret = store.state.user.secret
    let token = store.state.user.token
    let salt = new Date().getTime()
    for (let key in data) {
      if (data[key] === undefined || data[key] === null || data[key] === '') delete data[key]
    }
    let params = {
      action,
      source: 1,
      ...data,
    }
    let uriStr = transferUriStr(params)
    let sign = encryption.sha1(`${salt}${secret}${token}&${uriStr}`)
    params = {
      sign,
      salt,
      token,
      ...params
    }

    return axios.get(url, { params })
  },

  // 普通请求
  get(action, data, baseUrl) {
    delete axios.defaults.headers.token
    delete axios.defaults.headers.i18n
    delete axios.defaults.headers.sign
    // 相关微服务如UPG请求需要请求头上加上上面三个参数，但在公版接口下不需要请求头加参数，虽然在request请求数据返回时的拦截器删除了请求头上的参数，
    // 但还是会出现在UPG界面请求了UPG接口，突然F5刷新整体系统，个别接口出现爆红，由于储能系统多为get请求，故在这做请求处理
    let _baseUrl = cookie.getCookie('baseUrl')
    let url = _baseUrl ? _baseUrl : baseUrl ? baseUrl : ''
    let secret = store.state.user.secret
    let token = store.state.user.token
    let salt = new Date().getTime()
    for (let key in data) {
      if (data[key] === undefined || data[key] === null || data[key] === '') delete data[key]
    }
    let params = {
      action,
      source: 1,
      ...data,
    }
  // 先用 transferUriStr 生成统一的编码字符串（用于签名计算）
  let uriStr = qs.stringify(params) // 注意：不包含 sign/token/salt
  let sign = encryption.sha1(`${salt}${secret}${token}&${uriStr}`)

  // 把 sign、salt、token 加回参数对象并序列化为 queryString（与签名时同一编码器）
  let fullParamsObj = {
    sign,
    salt,
    token,
    ...params
  }
  let fullQuery = qs.stringify(fullParamsObj)

  // 统一通过拼接 URL 的方式发起请求，避免 axios 内部 params 序列化差异
  return axios.get(url + '?' + fullQuery)
  },
  post(action, data) {
    let secret = store.state.user.secret
    let token = store.state.user.token
    let salt = new Date().getTime()

    let params = {
      action,
      source: 1,
      devcode: data.devcode,
      devaddr: data.devaddr,
      sn: data.sn,
      pn: data.pn,
    }
    for (let key in params) {
      if (params[key] === undefined || params[key] === null || params[key] === '') delete params[key]
    }
    let uriStr = transferUriStr(params)
    let sign = encryption.sha1(`${salt}${secret}${token}&${uriStr}`)
    params = qs.stringify({
      sign,
      salt,
      token,
      ...params
    })
    let url = `?${params}`
    let config = {
      headers: { 'Content-Type': 'multipart/form-data' }
    }
    return axios.post(url, data, config)
  },
  RolePostPermissions(action, data) {
    let secret = store.state.user.secret
    let token = store.state.user.token
    let salt = new Date().getTime()

    let params = {
      action,
      source: 1,
    }
    for (let key in params) {
      if (params[key] === undefined || params[key] === null || params[key] === '') delete params[key]
    }
    let uriStr = transferUriStr(params)
    let sign = encryption.sha1(`${salt}${secret}${token}&${uriStr}`)
    params = qs.stringify({
      sign,
      salt,
      token,
      ...params
    })
    let url = `?${params}`
    let config = {
      headers: { 'Content-Type': 'multipart/form-data' }
    }
    return axios.post(url, data, config)
  },
  postDeviceParsSort(action, data) {
    let secret = store.state.user.secret
    let token = store.state.user.token
    let salt = new Date().getTime()

    let params = {
      action,
      source: 1,
    }
    for (let key in params) {
      if (params[key] === undefined || params[key] === null || params[key] === '') delete params[key]
    }
    let uriStr = transferUriStr(params)
    let sign = encryption.sha1(`${salt}${secret}${token}&${uriStr}`)
    params = qs.stringify({
      sign,
      salt,
      token,
      ...params
    })
    let url = `?${params}`
    let config = {
      // headers: { 'Content-Type': 'multipart/form-data' } 
      headers: { "Content-Type": "application/json" },
      // headers: { "Content-Type": "application/x-www-form-urlencoded" },
    }
    return axios.post(url, data, config)
  },
  // 无鉴权的请求手机号和邮箱获取验证码/网站首页公告/无鉴权节点请求
  get1(action, data, baseUrl, open) {
    let url = baseUrl ? baseUrl : ""
    let salt = new Date().getTime()
    for (let key in data) {
      if (data[key] === undefined || data[key] === null || data[key] === '') delete data[key]
    }
    let params = {
      action,
      source: 1,
      ...data,
    }
    let uriStr = transferUriStr(params)
    let sign = encryption.sha1(`${salt}&${uriStr}`)
    params = {
      sign,
      salt,
      ...params,
    }
    if (open) {
      window.open(url + '?' + transferUriStr(params), '_blank')
    }
    return axios.get(url, { params })
  },
  // 上传文件 好像是没用到的封装
  upload(action, data, file, baseUrl) {
    let secret = store.state.user.secret
    let token = store.state.user.token
    let salt = new Date().getTime()
    baseUrl = baseUrl || 'http://img.shinemonitor.com/file/'

    let params = {
      action,
      source: 1,
      ...data,
    }
    let uriStr = transferUriStr(params)
    let sign = encryption.sha1(`${salt}${secret}${token}&${uriStr}`)
    params = qs.stringify({
      sign,
      salt,
      token: token,
      ...params
    })
    let url = `${baseUrl}?${params}`

    let param = new FormData()
    param.append('file', file)
    let config = {
      headers: { 'Content-Type': 'multipart/form-data' }
    }
    return axios.post(url, param, config)
  },
  // 上传图片
  uploadImage(file) {
    let secret = store.state.user.secret
    let token = store.state.user.token
    let salt = new Date().getTime()

    let params = {
      action: 'uploadImg',
      source: 1,
      thumbnail: true,
    }
    let uriStr = transferUriStr(params)
    let sign = encryption.sha1(`${salt}${secret}${token}&${uriStr}`)
    params = qs.stringify({
      sign,
      salt,
      token,
      ...params
    })
    let defaultsBaseURL = config.env == "production" ? document.location.protocol + '//img.shinemonitor.com/file/' : document.location.protocol + '//solar.test.eybond.com/file/'
    let url = `${defaultsBaseURL}?${params}`
    // let url = `http://img.shinemonitor.com/file/?${params}`
    let param = new FormData()
    param.append('file', file)
    let configs = {
      headers: { 'Content-Type': 'multipart/form-data' }
    }
    return axios.post(url, param, configs)
  },
  //上传固件
  uploadfileAxios(file, desc, remark) {
    // let secret = store.state.user.secret
    // let token = store.state.user.token
    // let salt = new Date().getTime()

    // let params = {
    //   action: 'uploadFirmware',
    //   source: 1,
    //   desc,
    // }
    // let uriStr = transferUriStr(params)
    // let sign = encryption.sha1(`${salt}${secret}${token}&${uriStr}`)
    // params = qs.stringify({
    //   sign,
    //   salt,
    //   token,
    //   ...params
    // })
    // // let defaultsBaseURL = axios.defaults.baseURL == document.location.protocol + '//solar.eybond.com/test/'? document.location.protocol + '//solar.eybond.com/file/' : document.location.protocol + '//img.shinemonitor.com/file/'
    // let url = `?${params}`
    // // let url = _baseUrl ? _baseUrl : baseUrl ? baseUrl : ''
    // let param = new FormData()
    // param.append('file', file)
    // let config = {
    //   headers: { 'Content-Type': 'multipart/form-data' }
    // }
    // return axios.post(url, param, config)

    let url = currentNodeUPG()
    let uri = '/upg/api/auth/web/shineDess/device/upgrade/uploadFirmware'
    axios.defaults.headers["token"] = store.state.user.token;
    axios.defaults.headers["i18n"] = Lang.currentLang;
    let secret = store.state.user.secret
    let sign = hmacSHA256(uri, secret).toString();
    axios.defaults.headers["sign"] = sign;
    let param = new FormData();
    param.append("file", file);
    if (desc !== null && desc !== undefined) {
      param.append("desc", desc);
    }
    if (remark !== null && remark !== undefined) {
      param.append("remark", remark);
    }
    let urls;
    urls = url + uri
    return axios.post(urls, param, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  uploadfilesAxios(formData) {

    let url = currentNodeUPG()
    // let uri = '/upg/api/auth/web/shineDess/device/upgrade/uploadFirmware'
    let uri = '/upg/api/auth/web/device/firmware/batch'
    axios.defaults.headers["token"] = store.state.user.token;
    axios.defaults.headers["i18n"] = Lang.currentLang;
    let secret = store.state.user.secret
    let sign = hmacSHA256(uri, secret).toString();
    axios.defaults.headers["sign"] = sign;
    // let param = new FormData();
    // param.append("file", file);
    // if (desc !== null && desc !== undefined) {
    //   param.append("desc", desc);
    // }
    // if (remark !== null && remark !== undefined) {
    //   param.append("remark", remark);
    // }
    let urls;
    urls = url + uri
    return axios.post(urls, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  //批量绑定
  uploadBounding(action, file) {
    let secret = store.state.user.secret
    let token = store.state.user.token
    let salt = new Date().getTime()

    let params = {
      action
    }
    let uriStr = transferUriStr(params)
    let sign = encryption.sha1(`${salt}${secret}${token}&${uriStr}`)
    params = qs.stringify({
      sign,
      salt,
      token,
      ...params
    })
    // let defaultsBaseURL = axios.defaults.baseURL == document.location.protocol + '//solar.eybond.com/test/'? document.location.protocol + '//solar.eybond.com/file/' : document.location.protocol + '//img.shinemonitor.com/file/'
    let url = `?${params}`
    // let url = _baseUrl ? _baseUrl : baseUrl ? baseUrl : ''
    let param = new FormData()
    param.append('file', file)
    let config = {
      headers: { 'Content-Type': 'multipart/form-data' }
    }
    return axios.post(url, param, config)
  },
  //UPG上传固件
  uploadFirmware(uri, file, params) {
    let url = currentNodeUPG()
    axios.defaults.headers["token"] = store.state.user.token;
    axios.defaults.headers["i18n"] = Lang.currentLang;
    let secret = store.state.user.secret
    let sign = hmacSHA256(uri, secret).toString();
    axios.defaults.headers["sign"] = sign;
    let param = new FormData();
    param.append("file", file);
    param.append("firmwareName", params.firmwareName);
    param.append("firmwareVersion", params.versionNote);
    param.append("deleteFlag", params.deleteFlag);
    param.append("upgradeMode", params.upgradeMode);
    // param.append("note", params.note);
    // param.append("i18n", params.i18n);
    if (params.note !== null && params.note !== undefined) param.append("note", params.note);
    if (params.i18n !== null && params.i18n !== undefined) param.append("i18n", params.i18n);
    let urls;
    urls = url + uri
    return axios.post(urls, param, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  postUPG(action, data, baseUrl, config = {}) {
    let url = currentNodeUPG()
    axios.defaults.headers["token"] = store.state.user.token;
    axios.defaults.headers["i18n"] = Lang.currentLang;
    let secret = store.state.user.secret
    let sign = hmacSHA256(action, secret).toString();
    axios.defaults.headers["sign"] = sign;
    for (let key in data) {
      if (data[key] === undefined || data[key] === null || data[key] === "") {
        delete data[key];
      }
    }
    let urls;
    urls = url + action
    // 构建请求头
    let headers = { "Content-Type": "application/json" };
    // 当接口为 /upg/api/auth/web/device/upgradeTransmission 时携带 PN
    if (action == "/upg/api/auth/web/device/upgradeTransmission" && data.pn) {
      headers["X-Device-Pn"] = data.pn;
    }
    return axios.post(urls, data, {
      headers: headers,
      ...config,
    });
  },
  getUPG(action, data, baseUrl) {
    let uri = currentNodeUPG()
    axios.defaults.headers["i18n"] = Lang.currentLang;
    axios.defaults.headers["token"] = store.state.user.token;
    let secret = store.state.user.secret
    let sign = hmacSHA256(action, secret).toString();
    axios.defaults.headers["sign"] = sign;
    for (let key in data) {
      if (data[key] === undefined || data[key] === null || data[key] === "") {
        delete data[key];
      }
    }
    let params = {
      ...data,
    };
    let url = uri + action
    return axios.get(url, { params });
  },
  // upg put请求
  put(action, data, baseUrl) {
    let uri = currentNodeUPG()
    let secret = store.state.user.secret;
    axios.defaults.headers["i18n"] = Lang.currentLang;
    axios.defaults.headers["token"] = store.state.user.token;
    let sign = hmacSHA256(action, secret).toString();
    axios.defaults.headers["sign"] = sign;
    for (let key in data) {
      if (data[key] === undefined || data[key] === null) {
        delete data[key];
      }
    }
    let url = uri + action
    return axios.put(url, data, {
      headers: { "Content-Type": "application/json" },
    });
  },
  putUPG(action, data, baseUrl) {
    let uri = currentNodeUPG()
    let secret = store.state.user.secret;
    axios.defaults.headers["i18n"] = Lang.currentLang;
    axios.defaults.headers["token"] = store.state.user.token;
    let sign = hmacSHA256(action, secret).toString();
    axios.defaults.headers["sign"] = sign;
    for (let key in data) {
      if (data[key] === undefined || data[key] === null) {
        delete data[key];
      }
    }
    let params = { ...data }; // 将参数对象展开到params中
    let url = `${uri}${action}?${new URLSearchParams(params).toString()}`; // 将参数拼接到地址后面
    return axios.put(url); // 发送带有参数的PUT请求
  },
  // upg delete请求
  delete(action, data, baseUrl) {
    let uri = currentNodeUPG()
    let secret = store.state.user.secret;
    axios.defaults.headers["i18n"] = Lang.currentLang;
    axios.defaults.headers["token"] = store.state.user.token;
    let sign = hmacSHA256(action, secret).toString();
    axios.defaults.headers["sign"] = sign;
    for (let key in data) {
      if (data[key] === undefined || data[key] === null || data[key] === "") {
        delete data[key];
      }
    }
    let params = {
      ...data,
    };
    let url = uri + action
    return axios.delete(url, { params });
  },
  // 下载UPG固件
  postDownload(uri, data) {
    axios.defaults.headers["i18n"] = Lang.currentLang;
    let url = currentNodeUPG()
    axios.defaults.headers['token'] = store.state.user.token;
    let secret = store.state.user.secret
    let sign = hmacSHA256(uri, secret).toString()
    axios.defaults.headers['sign'] = sign
    for (let key in data) {
      if (data[key] === undefined || data[key] === null || data[key] === '') {
        delete data[key]
      }
    }
    let urls = url + uri
    return axios({
      method: 'get',
      url: urls,
      data: data,
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json'
      },
    })


  },
  getHMI(action, data, baseUrl) {
    // let uri = config.env == "production" ? document.location.protocol + "//hmi.eybond.com" : document.location.protocol + "//dev.eybond.com"
    let uri = config.env == "production" ? document.location.protocol + "//hmi.eybond.com" : document.location.protocol + "//solar.test.eybond.com"
    for (let key in data) {
      if (data[key] === undefined || data[key] === null || data[key] === "") {
        delete data[key];
      }
    }
    let params = {
      ...data,
    };
    let url = uri + action
    return axios.get(url, { params });
  },
  getAAM(action, i18n, domain) {
    let params = {
      i18n,
      action,
      domain
    }
    let url;
    if (config.env === 'development' || config.env === 'test') {
      url = 'http://test.eybond.com:9167/ws/'
    } else if (config.env === 'production') {
      url = 'https://aam.eybond.com/ws/'
    }
    //  axios.defaults.headers["i18n"] = i18n;
    return axios.get(url, { params })
  },
  getCRM(action,data) {
    // axios.defaults.headers["token"] = store.state.user.token;
    axios.defaults.headers["i18n"] = Lang.currentLang;
    let params = {
       ...data
    }
    let url;
    if (config.env === 'development' || config.env === 'test') {
      url = 'http://api.dev.valueclouds.com'+action
    } else if (config.env === 'production') {
      url =  document.location.protocol +'//api.valueclouds.com'+action
    }
    //  axios.defaults.headers["i18n"] = i18n;
    return axios.get(url, { params })
  },
  getPPR(action,data) {
    // axios.defaults.headers["token"] = store.state.user.token;
    axios.defaults.headers["i18n"] = Lang.currentLang;
    // axios.defaults.headers["project"] = 'DESS';
    let params = {
       ...data
    }
    let url;
    if (config.env === 'development' || config.env === 'test') {
      url = 'http://api.dev.valueclouds.com'+action
    } else if (config.env === 'production') {
      url =  document.location.protocol +'//api.valueclouds.com'+action
    }
    //  axios.defaults.headers["i18n"] = i18n;
    return axios.get(url, { params,              headers: {
      'project': 'DESS', // 
  } })
  },
  //批量上传数采器
  uploadCollector(file, data) {
    let secret = store.state.user.secret
    let token = store.state.user.token
    let salt = new Date().getTime()

    let params = {
      ...data,
      source: 1,
    }
    let uriStr = transferUriStr(params)
    let sign = encryption.sha1(`${salt}${secret}${token}&${uriStr}`)
    params = qs.stringify({
      sign,
      salt,
      token,
      ...params
    })
    // let defaultsBaseURL = axios.defaults.baseURL == document.location.protocol + '//solar.eybond.com/test/'? document.location.protocol + '//solar.eybond.com/file/' : document.location.protocol + '//img.shinemonitor.com/file/'
    let url = `?${params}`
    // let url = _baseUrl ? _baseUrl : baseUrl ? baseUrl : ''
    let param = new FormData()
    param.append('file', file)
    let config = {
      headers: { 'Content-Type': 'multipart/form-data' }
    }
    return axios.post(url, param, config)
  },
  //OTA日月元升级
  OTAuploadCollector(file, data) {
    let secret = store.state.user.secret
    let token = store.state.user.token
    let salt = new Date().getTime()

    let params = {
      ...data,
      source: 1,
    }
    let uriStr = qs.stringify(params)
    let sign = encryption.sha1(`${salt}${secret}${token}&${uriStr}`)
    params = qs.stringify({
      sign,
      salt,
      token,
      ...params
    })
    // let defaultsBaseURL = axios.defaults.baseURL == document.location.protocol + '//solar.eybond.com/test/'? document.location.protocol + '//solar.eybond.com/file/' : document.location.protocol + '//img.shinemonitor.com/file/'
    let url = `?${params}`
    // let url = _baseUrl ? _baseUrl : baseUrl ? baseUrl : ''
    let param = new FormData()
    param.append('file', file)
    let config = {
      headers: { 'Content-Type': 'multipart/form-data' }
    }
    return axios.post(url, param, config)
  },
  // 修改密码
  changePwd(newPwd, oldPwd) {
    let sha1newPwd = encryption.sha1(newPwd)
    let sha1oldPwd = encryption.sha1(oldPwd)
    let rcPWD = encryption.rc4(sha1newPwd, sha1oldPwd)
    var newpwd = encryption.byte2hex(rcPWD)
    // let params={
    //   newpwd,
    //   source: 1,
    // }

    return this.get('updatePassword', { newpwd })
  },
  // 找回密码中用手机号提交新密码
  changePwds({ usr, pwd, mobile, msgType, channel, smsCode, webName }) {
    let salt = new Date().getTime()
    // 密码加密
    let pwdSha1 = encryption.sha1(pwd)
    // let pnSha1 = encryption.sha1(pn)
    let rc4Result = encryption.byte2hex(encryption.rc4(pwdSha1, mobile))
    let params = {
      action: 'smsCodeUpdatePassword',
      usr,
      msgType,
      channel,
      smsCode,
      pwd: rc4Result,
      mobile: mobile,
      webName: webName,
      source: 1,
    }
    let uriStr = transferUriStr(params)
    let sign = encryption.sha1(`${salt}${pwdSha1}&${uriStr}`)
    params = { sign, salt, ...params }
    return axios.get('', { params })
  },
  // 找回密码中用邮箱提交新密码
  changesPwd({ usr, pwd, email, msgType, channel, smsCode, webName }) {
    let salt = new Date().getTime()
    // 密码加密
    let pwdSha1 = encryption.sha1(pwd)
    let rc4Result = encryption.byte2hex(encryption.rc4(pwdSha1, email))
    let params = {
      action: 'smsCodeUpdatePassword',
      usr,
      msgType,
      channel,
      smsCode,
      pwd: rc4Result,
      email: email,
      webName: webName,
      source: 1,
    }
    let uriStr = transferUriStr(params)
    let sign = encryption.sha1(`${salt}${pwdSha1}&${uriStr}`)
    params = { sign, salt, ...params }
    return axios.get('', { params })
  },

  // 自填鉴权信息请求
  customGet(info, action, data, baseUrl) {
    delete axios.defaults.headers.token
    delete axios.defaults.headers.i18n
    delete axios.defaults.headers.sign
    // 相关微服务如UPG请求需要请求头上加上上面三个参数，但在公版接口下不需要请求头加参数，虽然在request请求数据返回时的拦截器删除了请求头上的参数，
    // 但还是会出现在UPG界面请求了UPG接口，突然F5刷新整体系统，个别接口出现爆红，由于储能系统多为get请求，故在这做请求处理
    let _baseUrl = cookie.getCookie('baseUrl')
    let url = _baseUrl ? _baseUrl : baseUrl ? baseUrl : ''
    let secret = info.secret
    let token = info.token
    let salt = new Date().getTime()
    for (let key in data) {
      if (data[key] === undefined || data[key] === null || data[key] === '') delete data[key]
    }
    let params = {
      action,
      source: 1,
      ...data,
    }
    let uriStr = transferUriStr(params)
    let sign = encryption.sha1(`${salt}${secret}${token}&${uriStr}`)
    if (action == 'adminQueryUsrAccount') {
      params = transferUriStr({
        sign,
        salt,
        token,
        ...params
      })
      return axios.get(url + '?' + params)
    } else {
      params = {
        sign,
        salt,
        token,
        ...params
      }
      return axios.get(url, { params })
    }
  },

  knoxGet(action, data, baseUrl) {
    delete axios.defaults.headers.token
    delete axios.defaults.headers.i18n
    delete axios.defaults.headers.sign
    // 相关微服务如UPG请求需要请求头上加上上面三个参数，但在公版接口下不需要请求头加参数，虽然在request请求数据返回时的拦截器删除了请求头上的参数，
    // 但还是会出现在UPG界面请求了UPG接口，突然F5刷新整体系统，个别接口出现爆红，由于储能系统多为get请求，故在这做请求处理
    let _baseUrl = cookie.getCookie('baseUrl')
  let url = document.location.protocol+'//dis-knox.dessmonitor.com/public/'
    let secret = store.state.user.secret
    let token = store.state.user.token
    let salt = new Date().getTime()
    for (let key in data) {
      if (data[key] === undefined || data[key] === null || data[key] === '') delete data[key]
    }
    let params = {
      action,
      source: 1,
      ...data,
    }
    let uriStr = transferUriStr(params)
    let sign = encryption.sha1(`${salt}${secret}${token}&${uriStr}`)
    if (action == 'adminQueryUsrAccount') {
      params = transferUriStr({
        sign,
        salt,
        token,
        ...params
      })
      return axios.get(url + '?' + params)
    } else {
      params = {
        sign,
        salt,
        token,
        ...params
      }
      return axios.get(url, { params })
    }
  },

    // 微服务普通请求 测试，开发，正式使用价值云域名，正式环境进行prodMicroserviceUrl判断
  postDEVMicroservices(action, data, baseUrl) {
    delete axios.defaults.headers.token
    delete axios.defaults.headers.i18n
    delete axios.defaults.headers.sign
    let url;
    if (config.env === 'development') {
      url = 'http://api.dev.valueclouds.com'+action
    } else if (config.env === 'test') {
      url = 'http://api.test.valueclouds.com'+action
    } else if (config.env === 'production') {
      url = prodMicroserviceUrl(action, document.location.protocol +'//api.valueclouds.com')
    }
    // 从 store 获取动态 token/secret/Auth，如果没有则使用默认值
    let token = store.state.user.token 
    let secret = store.state.user.secret 
    let Auth = store.state.user.pprAuth 
    let salt = new Date().getTime()
    for (let key in data) {
      if (data[key] === undefined || data[key] === null || data[key] === '') delete data[key]
    }
    let params = {
      // action,
      ...data,
    }
    let uriStr = transferUriStr(params)

    // let sign = encryption.sha1(`${salt}${secret}${token}&${uriStr}`)
    let sign = hmacSHA256(action, secret).toString();
    params = {
      // sign,
      // salt,
      // token,
      ...params
    }
    // 添加 token 到请求标头
    // 数据明细导出接口返回文件流，需以blob接收
    if (action === "/drt/api/auth/web/exportDeviceDat") {
      return axios({
        method: "post",
        url: url,  // url在函数开头已拼接action，不可重复拼接
        data: params,
        headers: {
            'Content-Type': 'application/json',
            'token': token,
            'sign': sign,
            'project': 'DESS',
            'Auth': Auth,
            'i18n':Lang.currentLang,
        },
        responseType: "blob",
        // responseType: "arraybuffer",
      }).catch(err => {
          console.log('网络失效');
          // Toaste({text:i18n.i18n.t("devInfo.z_deldsd")});
      });
    }
      return axios.post(url, params, {
        headers: {
            'Content-Type': 'application/json',
            'token': token,
            'sign': sign,
            'project': 'DESS',
            'Auth': Auth,
            'i18n':Lang.currentLang,
        }
      }).catch(err => {
          console.log('网络失效');
          // Toaste({text:i18n.i18n.t("devInfo.z_deldsd")});
      });
  },
  // 微服务普通请求 测试，开发，正式使用价值云域名，正式环境进行prodMicroserviceUrl判断
  getDEVMicroservices(action, data, baseUrl) {
    delete axios.defaults.headers.token
    delete axios.defaults.headers.i18n
    delete axios.defaults.headers.sign
    let url;
    if (config.env === 'development') {
      url = 'http://api.dev.valueclouds.com'+action
    } else if (config.env === 'test') {
      url = 'http://api.test.valueclouds.com'+action
    } else if (config.env === 'production') {
      url = prodMicroserviceUrl(action, document.location.protocol +'//api.valueclouds.com')
    }
    // 从 store 获取动态 token/secret/Auth，如果没有则使用默认值
    let token = store.state.user.token 
    let secret = store.state.user.secret 
    let Auth = store.state.user.pprAuth 
    let salt = new Date().getTime()
    for (let key in data) {
      if (data[key] === undefined || data[key] === null || data[key] === '') delete data[key]
    }
    let params = {
      // action,
      ...data,
    }
    let uriStr = transferUriStr(params)

    // let sign = encryption.sha1(`${salt}${secret}${token}&${uriStr}`)
    let sign = hmacSHA256(action, secret).toString();
    params = {
      // sign,
      // salt,
      // token,
      ...params
    }
    // 添加 token 到请求标头
      return axios.get(url, {
        params: params,
        headers: {
            'token': token, // 将 token 添加到请求标头
            'sign': sign, // 
            'project': 'DESS', // 
            'Auth': Auth, // 
            'i18n':Lang.currentLang, // 
        }
      }).catch(err => {
          console.log('网络失效');
          // Toaste({text:i18n.i18n.t("devInfo.z_deldsd")});
      });
  },
  // 微服务普通请求 测试，开发，正式使用储能域名默认，正式进行prodMicroserviceUrl判断
  getMicroserDess(action, data, baseUrl) {
    delete axios.defaults.headers.token
    delete axios.defaults.headers.i18n
    delete axios.defaults.headers.sign
    let url;
    if (config.env === 'development') {
      url = document.location.protocol + '//ess.dev.eybond.com'+action
    } else if (config.env === 'test') {
      url = document.location.protocol + '//ess.test.eybond.com'+action
    } else if (config.env === 'production') {
      url = prodMicroserviceUrl(action, document.location.protocol +'//web.dessmonitor.com')
    }
    // 从 store 获取动态 token/secret/Auth，如果没有则使用默认值
    let token = store.state.user.token 
    let secret = store.state.user.secret 
    let Auth = store.state.user.pprAuth 
    let salt = new Date().getTime()
    for (let key in data) {
      if (data[key] === undefined || data[key] === null || data[key] === '') delete data[key]
    }
    let params = {
      // action,
      ...data,
    }
    let uriStr = transferUriStr(params)

    // let sign = encryption.sha1(`${salt}${secret}${token}&${uriStr}`)
    let sign = hmacSHA256(action, secret).toString();
    params = {
      // sign,
      // salt,
      // token,
      ...params
    }
    // 添加 token 到请求标头
      return axios.get(url, {
        params: params,
        headers: {
            'token': token, // 将 token 添加到请求标头
            'sign': sign, // 
            'project': 'DESS', // 
            'Auth': Auth, // 
            'i18n':Lang.currentLang, // 
        }
      }).catch(err => {
          console.log('网络失效');
          // Toaste({text:i18n.i18n.t("devInfo.z_deldsd")});
      });
  },
  // 微服务普通请求 测试，开发，正式使用储能域名默认，正式进行prodMicroserviceUrl判断
  postMicroserDess(action, data, baseUrl) {
    delete axios.defaults.headers.token
    delete axios.defaults.headers.i18n
    delete axios.defaults.headers.sign
    let url;
    if (config.env === 'development') {
      url = document.location.protocol + '//ess.dev.eybond.com'+action
    } else if (config.env === 'test') {
      url = document.location.protocol + '//ess.test.eybond.com'+action
    } else if (config.env === 'production') {
      url = prodMicroserviceUrl(action, document.location.protocol +'//web.dessmonitor.com')
    }
    // 从 store 获取动态 token/secret/Auth，如果没有则使用默认值
    let token = store.state.user.token 
    let secret = store.state.user.secret 
    let Auth = store.state.user.pprAuth 
    let salt = new Date().getTime()
    for (let key in data) {
      if (data[key] === undefined || data[key] === null || data[key] === '') delete data[key]
    }
    let params = {
      // action,
      ...data,
    }
    let uriStr = transferUriStr(params)

    // let sign = encryption.sha1(`${salt}${secret}${token}&${uriStr}`)
    let sign = hmacSHA256(action, secret).toString();
    params = {
      // sign,
      // salt,
      // token,
      ...params
    }
    // 添加 token 到请求标头
        // 数据明细导出接口返回文件流，需以blob接收
    if (action === "/drt/api/auth/web/exportDeviceDat") {
      return axios({
        method: "post",
        url: url,  // url在函数开头已拼接action，不可重复拼接
        data: params,
        headers: {
            'Content-Type': 'application/json',
            'token': token,
            'sign': sign,
            'project': 'DESS',
            'Auth': Auth,
            'i18n':Lang.currentLang,
        },
        responseType: "blob",
        // responseType: "arraybuffer",
      }).catch(err => {
          console.log('网络失效');
          // Toaste({text:i18n.i18n.t("devInfo.z_deldsd")});
      });
    }
      return axios.post(url, params, {
        headers: {
            'Content-Type': 'application/json',
            'token': token,
            'sign': sign,
            'project': 'DESS',
            'Auth': Auth,
            'i18n':Lang.currentLang,
        }
      }).catch(err => {
          console.log('网络失效');
          // Toaste({text:i18n.i18n.t("devInfo.z_deldsd")});
      });
  },
  postINP(action, data) {
    axios.defaults.headers.i18n = "zh_CN"
    for (let key in data) {
      if (data[key] === undefined || data[key] === null || data[key] === '') delete data[key]
    }
    // let urlSD =  'http://test.eybond.com:9199'
    // // let urlSD =  'http://gip.shinemonitor.com'
    // let url = urlSD + action
    let url;
    if (config.env === 'development') {
      url = 'http://test.eybond.com:9199'+action
    } else if (config.env === 'test') {
      url = 'http://test.eybond.com:9199'+action
    } else if (config.env === 'production') {
      url =  'http://gip.shinemonitor.com'+action
    }
    return axios.post(url, data, {
        headers: {
            'Content-Type': 'application/json',
        }
      }).catch(err => {
          console.log('网络失效');
          // Toaste({text:i18n.i18n.t("devInfo.z_deldsd")});
      });
  },
  getINP(action, data) {
    axios.defaults.headers.i18n = "zh_CN"
    for (let key in data) {
      if (data[key] === undefined || data[key] === null || data[key] === '') delete data[key]
    }
    // let INPurl = 'http://gip.shinemonitor.com'
    // let urlINP = INPurl + action
    let urlINP;
    if (config.env === 'development') {
      urlINP = 'http://test.eybond.com:9199'+action
    } else if (config.env === 'test') {
      urlINP = 'http://test.eybond.com:9199'+action
    } else if (config.env === 'production') {
      urlINP =  'http://gip.shinemonitor.com'+action
    }
    return axios.get(urlINP, data)
  },

}